import { Box } from "@material-ui/core";
import CommentBox from "../../Utilities/Comments/CommentBox";
import CommentPlaceholder from "../../Utilities/Comments/CommentPlaceholder";
import SequencerChats from "../PlayerView/SequencerChats";
import useCommentsPanelStyles from "./SequencerMixCommentsPanel.styles";

const SequencerMixVersionCommentsPanel = ({
  selectedVersion,
  currentTime,
  isVideoPlaying,
  refreshCounter,
  setRefreshCounter,
  projectId,
  setScreenshot,
  screenshot,
  canvasModal,
  setCanvasModal,
}) => {
  const classes = useCommentsPanelStyles();
  const canShowComments = typeof selectedVersion === 'object' && selectedVersion?.shotVersion && !isVideoPlaying;

  return (
    <Box className={classes.content}>
      <Box className={classes.versionCommentsBody}>
        {canShowComments ? (
          <SequencerChats
            selectedVersion={selectedVersion}
            refreshCounter={refreshCounter}
            embedded
          />
        ) : (
          <CommentPlaceholder />
        )}
      </Box>
      {canShowComments ? (
        <Box className={classes.versionCommentInput}>
          <CommentBox
            currentTime={currentTime}
            selectedVersion={selectedVersion}
            refreshCounter={refreshCounter}
            setRefreshCounter={setRefreshCounter}
            projectId={projectId}
            setScreenshot={setScreenshot}
            screenshot={screenshot}
            canvasModal={canvasModal}
            setCanvasModal={setCanvasModal}

          />
        </Box>
      ) : null}
    </Box>
  );
};

export default SequencerMixVersionCommentsPanel;
